
import styled, { css, keyframes } from 'styled-components';

export interface StyleProps {
  margin?: string;
}

export const Spinner = styled.div`
    width: 40px;
    height: 40px;
    position: relative;
    margin: ${(props: StyleProps) => props.margin ? props.margin : '100px auto'};
`

export const skbounce = keyframes` 
    0%, 100% { 
      transform: scale(0.0);
    } 50% { 
      transform: scale(1.0);
    }
`
export const bounce = props =>
  css`
    ${skbounce} 2.0s infinite ease-in-out;
  `

export const DoubleBounce1 = styled.div`
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: #373F53;
    opacity: 0.6;
    position: absolute;
    top: 0;
    left: 0;
    animation: ${bounce};
`;

export const DoubleBounce2 = styled.div`
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: #373F53;
    opacity: 0.6;
    position: absolute;
    top: 0;
    left: 0;
    animation: ${bounce} ;
    animation-delay: -1.0s;
`

